import { axiosConfig } from "axios/axios.config";

class V1WebRootService {
  initUser() {
    return axiosConfig.get("v1/web/init/user/");
  }
}

export default new V1WebRootService();